import { getJSON } from 'bv-fetch';

const fetchButtons = () => getJSON('/api/site_navigation/floating_navigation');

export default fetchButtons;
